import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconContract$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconContract extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '760c0ec27514d76ee770e94c08061a847b3cc54a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1ae82055c19e6b47b0a2bc585b44f166d324bba8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bca222acad54936f5cae08f7153d956e3f047448', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.034 10H12.4a.4.4 0 0 1-.4-.4V4.966a.4.4 0 0 1 .683-.283l1.778 1.778 2.632-2.638a.5.5 0 0 1 .707 0l.353.354a.5.5 0 0 1 0 .707l-2.636 2.638 1.8 1.795a.4.4 0 0 1-.283.683M7.52 15.52l-2.655 2.657a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l2.654-2.657-1.776-1.776A.4.4 0 0 1 4.966 12H9.6a.4.4 0 0 1 .4.4v4.634a.4.4 0 0 1-.68.286z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-contract", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-contract"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-contract":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconContract$1);
            }
            break;
    } });
}

const CosmosIconContract = CosmosIconContract$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconContract, defineCustomElement };
